import { Reveal } from './Reveal';
import { MayorSeal, BiotechSeal, InstituteSeal, LegalSeal } from './Seals';
import { SIBLINGS } from '../data/content';

const SEALS = {
  octavious: MayorSeal,
  solene: BiotechSeal,
  maeve: InstituteSeal,
  henrietta: LegalSeal,
};

export const Siblings = () => (
  <section id="family" className="py-24 lg:py-32 bg-[#200D0E]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <div>
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-gold mb-5">The Family</p>
          <h2 className="font-serif font-medium text-4xl sm:text-5xl text-[#F2E5CF] tracking-tight leading-[1.08] max-w-xl">
            Four siblings. One foundation.
          </h2>
        </div>
        <p className="font-display text-sm text-[#94756A] max-w-xs leading-relaxed lg:text-right">
          Portraits from the permanent collection. The family declines interviews.
        </p>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {SIBLINGS.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.1}>
            <article data-testid={`sibling-card-${s.id}`} className="group">
              <div className="relative overflow-hidden aspect-[3/4] bg-[#2B1213]">
                <img
                  src={s.portrait}
                  alt={`Portrait of ${s.name}`}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 border border-transparent transition-colors duration-500 group-hover:border-gold/70 pointer-events-none" />
                <span
                  data-testid={`sibling-seal-${s.id}`}
                  className="absolute bottom-3 right-3 w-11 h-11 transition-transform duration-500 group-hover:rotate-12 drop-shadow-[0_0_8px_rgba(201,162,39,0.35)]"
                  title={s.domain}
                >
                  {(() => { const Seal = SEALS[s.id]; return <Seal />; })()}
                </span>
              </div>
              <h3 className="mt-5 font-serif font-semibold text-xl text-[#F2E5CF]">{s.name}</h3>
              <p className="mt-1 font-mono text-[10px] tracking-[0.22em] uppercase text-gold">{s.domain}</p>
              <p className="mt-3 text-sm text-[#B99C8B] leading-relaxed">{s.bio}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
